export default {
  common: {
    search: '查询',
    reset: '重置',
    save: '保存',
    delete: '删除',
    cancel: '取消',
    confirm: '确认',
    add: '新增',
    edit: '编辑',
    back: '返回',
    export: '导出',
    import: '导入',
    enable: '启用',
    disable: '禁用',
    operation: '操作',
    status: '状态',
    detail: '详情',
    view: '查看',
    copy: '复制',
    close: '关闭',
    submit: '提交',
    download: '下载',
    upload: '上传',
    refresh: '刷新',
    loading: '加载中...',
    noData: '暂无数据',
    success: '操作成功',
    failed: '操作失败',
    confirmDelete: '确认删除',
    confirmDeleteContent: '确定要删除吗？',
    ok: '确定',
    total: '共 {total} 条',
    selectPlaceholder: '请选择',
    inputPlaceholder: '请输入',
    startTime: '开始时间',
    endTime: '结束时间',
    today: '今日',
    yesterday: '昨日',
    week: '本周',
    month: '本月',
    all: '全部',
    yes: '是',
    no: '否',
    enabled: '已启用',
    disabled: '已禁用',
    id: '序号',
    createTime: '创建时间',
    updateTime: '更新时间',
    actions: '操作',
    saveConfig: '保存配置',
    batchEdit: '批量修改',
    viewMore: '查看更多',
    imageOnly: '请上传图片文件！请手动删除当前文件。',
    uploadFileSizeLimit: '上传文件大小不能超过10Mb！请手动删除当前文件。'
  },
  menu: {
    workplace: '工作台',
    peiwan: '我的报单',
    'peiwan-companion': '陪玩报单',
    personal: '个人中心',
    menu: '菜单管理',
    client: '客户管理',
    user: '用户管理',
    withdraw: '提现管理',
    dailian: '代练报单',
    gift: '礼物报单',
    dict: '字典管理',
    rankList: '排行榜',
    registerReview: '注册审核',
    orderReview: '报单审核',
    peiwanReview: '陪玩报单审核',
    dailianReview: '代练报单审核',
    giftReview: '礼物报单审核',
    role: '角色管理',
    log: '日志管理',
    aftersale: '售后管理',
    shop: '店铺配置',
    download: '下载中心',
    billing: '账单管理'
  },
  header: {
    personalCenter: '个人中心',
    settings: '设置',
    logout: '退出登录'
  },
  login: {
    title: 'catkiller gaming 管理后台',
    welcome: '欢迎回来',
    username: '用户名',
    password: '密码',
    rememberMe: '记住用户名和密码',
    register: '注册账号',
    login: '登录',
    placeholder: {
      username: '请输入用户名或邮箱',
      password: '请输入登录密码'
    }
  },
  register: {
    adminPanel: '管理后台',
    title: '用户注册',
    hasAccount: '已有账号？',
    loginNow: '立即登陆',
    step: {
      basic: '基本信息',
      identity: '实名信息'
    },
    form: {
      username: '用户名/账号',
      password: '登陆密码',
      nickname: '用户昵称',
      role: '报单角色',
      phone: '手机号',
      wechat: '微信号',
      realName: '真实姓名',
      idCard: '身份证号',
      alipay: '支付宝账号',
      address: '地址',
      passCode: '口令码'
    },
    placeholder: {
      username: '请输入用户名/账号',
      password: '请输入登录密码',
      nickname: '请输入用户昵称',
      phone: '请输入手机号',
      wechat: '请输入微信号',
      realName: '请输入真实姓名',
      idCard: '请输入身份证号',
      alipay: '请输入支付宝账号',
      address: '请输入地址',
      passCode: '请输入口令码，仅客服填'
    },
    role: {
      companion: '陪玩',
      booster: '代练'
    },
    next: '下一步',
    prev: '上一步',
    submit: '提交注册',
    success: '注册申请成功！等待管理员审核中...'
  },
  workplace: {
    overview: '工作台概览',
    greeting: {
      morning: '上午好',
      afternoon: '下午好',
      evening: '晚上好',
      welcome: '欢迎回来'
    },
    stats: {
      companion: '陪玩',
      companionTip: '统计系统中角色为陪玩(角色ID=1)的用户总数',
      booster: '代练',
      boosterTip: '统计系统中角色为代练(角色ID=2)的用户总数',
      revenue: '营业额',
      revenueTip: '所有有效订单(已审核通过及后续状态)的金额总和，排除待审核、已取消、已拒绝订单'
    },
    metrics: {
      todayRevenue: '今日营业额',
      todayRevenueTip: '今日创建的有效订单金额总和（排除待审核、已取消、已拒绝），与昨日对比计算环比',
      todayOrders: '今日订单量',
      todayOrdersTip: '今日创建的有效订单数量（排除待审核、已取消、已拒绝），与昨日对比计算环比',
      todayNewUsers: '今日新增用户',
      todayNewUsersTip: '今日注册的陪玩/代练用户数量，与昨日对比计算环比',
      todayNewCustomers: '今日新增客户',
      todayNewCustomersTip: '今日创建的客户数量，与昨日对比计算环比'
    },
    adminMetrics: {
      customerBalance: '客户总预存',
      customerBalanceTip: '所有客户当前余额的总和',
      customerReward: '成本总金额',
      customerRewardTip: '所有客户充值(赠送)交易总额',
      pendingOrderAmount: '待审核订单总金额',
      pendingOrderAmountTip: 'order_status=0(待审核)的订单金额总和',
      pendingOrderCount: '待审核订单数量',
      pendingOrderCountTip: 'order_status=0(待审核)的订单数量',
      approvedOrderAmount: '已审核通过订单总金额(审核通过但未申请提现)',
      approvedOrderAmountTip: 'order_status IN (3,4)的订单金额总和（审核通过+待提现）',
      approvedOrderCount: '已审核通过订单数量',
      approvedOrderCountTip: 'order_status IN (3,4)的订单数量',
      pendingSalaryAmount: '待发工资总金额(已申请提现)',
      pendingSalaryAmountTip: 'order_status=5(提现审核中)的订单金额总和',
      pendingSalaryCount: '待发工资订单数量',
      pendingSalaryCountTip: 'order_status=5(提现审核中)的订单数量'
    }
  },
  shop: {
    tabs: {
      commissionConfig: '抽成配置',
      gameConfig: '游戏配置',
      peiwanTypeConfig: '陪玩类型配置',
      vipLevelConfig: 'VIP等级配置',
      discountConfig: '折扣配置',
      withdrawConfig: '提现配置',
      tokenManagement: '口令码管理',
      departmentConfig: '部门配置',
      gameDict: '游戏字典',
      peiwanType: '陪玩类型'
    },
    config: {
      defaultCommission: '默认抽成配置',
      companionOrder: '陪玩订单抽成',
      boostOrder: '代练订单抽成',
      giftOrder: '礼物订单抽成',
      withdrawFreezeDays: '提现冻结天数',
      days: '天',
      lastUpdate: '上次更新：',
      operator: '操作人：',
      commissionHint: '更新后，新创建的用户将继承此默认抽成。已存在的用户抽成不受影响。',
      withdrawHint: '设置订单审核通过后，陪玩需要等待多少天才能申请提现。'
    },
    batch: {
      title: '批量调整抽成',
      warning: '批量调整将无差别覆盖全部用户的抽成比例，包括已手动调整过的用户。',
      applyAll: '一键应用到全部'
    },
    token: {
      title: '口令码管理',
      hint: '口令码用于用户注册时的身份验证，重置后旧口令码将立即失效。',
      status: '当前状态：',
      configured: '已配置',
      notConfigured: '未配置',
      randomGenerate: '随机生成新口令码',
      newToken: '新口令码：',
      copyHint: '请立即复制并保存此口令码，关闭后将无法再次查看！',
      manualSet: '手动设置口令码：',
      placeholder: '请输入新口令码（至少6位）',
      update: '更新',
      minLengthError: '口令码长度不能少于6位'
    },
    department: {
      title: '部门配置',
      add: '新增部门',
      edit: '编辑部门',
      save: '保存配置',
      code: '部门编码',
      name: '部门名称',
      codePlaceholder: '请输入部门编码',
      namePlaceholder: '请输入部门名称',
      hint: '部门配置用于用户管理和订单分配，请谨慎修改。',
      emptyError: '部门编码和名称不能为空',
      duplicateError: '部门编码已存在'
    },
    vipLevel: {
      title: 'VIP等级',
      add: '新增VIP等级',
      edit: '编辑VIP等级',
      columns: {
        id: 'VIP等级ID',
        name: 'VIP等级名称',
        key: 'VIP等级Key',
        type: 'VIP等级类型',
        discount: '折扣百分比',
        operation: '操作'
      },
      form: {
        name: 'VIP等级名称',
        key: 'VIP等级Key',
        type: 'VIP等级类型',
        description: 'VIP等级描述',
        discount: '折扣百分比'
      },
      placeholder: {
        name: '请输入VIP等级名称',
        key: '请输入VIP等级Key',
        type: '请输入VIP等级类型',
        description: '请输入VIP等级描述',
        discount: '请输入折扣百分比'
      }
    },
    discount: {
      title: '折扣配置',
      add: '新增折扣',
      edit: '编辑折扣',
      columns: {
        id: '折扣ID',
        name: '折扣名称',
        value: '折扣百分比',
        operation: '操作'
      },
      form: {
        name: '折扣名称',
        value: '折扣百分比'
      },
      placeholder: {
        name: '请输入折扣名称',
        value: '请输入折扣百分比'
      }
    },
    messages: {
      confirmBatchEdit: '确认批量修改',
      confirmBatchEditContent: '此操作将无差别覆盖全部用户的抽成比例（含已手动调整的），确定继续吗？',
      confirmOverwrite: '确认覆盖',
      batchEditSuccess: '批量修改成功，共影响 {affected} 个用户',
      confirmResetToken: '确认重置口令码',
      confirmResetTokenContent: '此操作将生成新的注册口令码，旧口令码将立即失效。确定继续吗？',
      confirmReset: '确认重置',
      tokenResetSuccess: '口令码已重置，请复制新口令码',
      confirmUpdateToken: '确认更新口令码',
      confirmUpdateTokenContent: '此操作将更新注册口令码，旧口令码将立即失效。确定继续吗？',
      confirmUpdate: '确认更新',
      tokenUpdateSuccess: '口令码已更新',
      tokenCopied: '口令码已复制到剪贴板',
      commissionUpdated: '默认抽成配置已更新',
      withdrawFreezeUpdated: '提现冻结天数已更新',
      departmentSaved: '部门配置已保存',
      confirmDeleteDepartment: '确认删除',
      confirmDeleteDepartmentContent: '确定要删除该部门吗？'
    },
    buttons: {
      save: '保存',
      copy: '复制'
    }
  },
  withdraw: {
    title: '提现管理',
    columns: {
      playerName: '陪玩名称',
      amount: '提现金额',
      orderType: '订单类型',
      department: '部属',
      project: '项目',
      payee: '收款人',
      payeePhone: '收款人电话',
      payeeWechat: '收款人微信',
      wechatQrcode: '微信收款码',
      alipayQrcode: '支付宝收款码',
      status: '审核状态',
      createTime: '发起时间',
      reviewTime: '审核时间',
      operation: '操作'
    },
    search: {
      playerName: '陪玩昵称',
      orderType: '订单种类',
      status: '审核状态',
      department: '部属',
      createTime: '发起时间',
      reviewTime: '审核时间'
    },
    placeholder: {
      playerName: '请输入陪玩昵称',
      orderType: '请选择订单种类',
      status: '请选择审核状态',
      department: '请选择部属'
    },
    detail: {
      playerUsername: '陪玩/代练用户名',
      playerNickname: '陪玩/代练名称',
      amount: '提现金额',
      status: '提现状态',
      createTime: '提现请求时间',
      reviewer: '审核人',
      reviewRemark: '审核备注',
      reviewTime: '审核时间',
      orderType: '订单类型'
    },
    buttons: {
      review: '审核',
      pass: '通过',
      reject: '拒绝'
    },
    messages: {
      confirmPass: '确认通过？',
      confirmReject: '确认拒绝？'
    }
  },
  user: {
    title: '用户管理',
    columns: {
      nickname: '昵称',
      username: '用户名',
      gender: '性别',
      avatar: '头像',
      role: '角色',
      department: '部属',
      balance: '钱包余额',
      withdrawableBalance: '可提现余额',
      companionCommission: '陪玩抽成',
      boostCommission: '代练抽成',
      giftCommission: '礼包抽成',
      phone: '电话',
      wechat: '微信号',
      alipay: '支付宝账号',
      wechatQrcode: '微信收款码',
      alipayQrcode: '支付宝收款码',
      email: '邮箱',
      qq: 'QQ号',
      birthday: '生日',
      bio: '个人简介',
      lastLogin: '上次登陆时间',
      status: '是否启用',
      operation: '操作'
    },
    search: {
      nickname: '用户昵称'
    },
    placeholder: {
      nickname: '请输入用户昵称'
    },
    buttons: {
      add: '新增用户',
      export: '导出',
      editCommission: '编辑抽成',
      edit: '编辑',
      resetPassword: '重置密码',
      leave: '退店'
    },
    tabs: {
      employee: '员工',
      companion: '陪玩/代练'
    },
    messages: {
      confirmDelete: '确认删除？',
      noPermission: '无操作权限',
      uploadSuccess: '上传成功！',
      uploadFailed: '上传失败'
    },
    form: {
      username: '用户名',
      password: '密码',
      newPassword: '新密码',
      nickname: '用户昵称',
      gender: '用户性别',
      role: '角色',
      department: '部属',
      phone: '用户电话',
      email: '用户邮箱',
      qq: '用户QQ',
      bio: '个人简介',
      status: '启用状态',
      authInfo: '实名信息',
      realName: '真实姓名',
      idCardNo: '身份证号',
      authPhone: '联系电话',
      wechat: '微信号',
      alipay: '支付宝账号',
      location: '地址',
      wechatQrcode: '微信收款码',
      alipayQrcode: '支付宝收款码',
      walletBalance: '钱包余额',
      companionCommission: '陪玩订单抽成',
      boostCommission: '代练订单抽成',
      giftCommission: '礼物订单抽成'
    },
    formPlaceholder: {
      username: '请输入用户名',
      password: '请输入密码',
      newPassword: '请输入新密码',
      nickname: '请输入用户昵称',
      gender: '请选择用户性别',
      role: '请选择用户角色',
      department: '请选择员工部属',
      phone: '请输入用户电话',
      email: '请输入用户邮箱',
      qq: '请输入用户QQ',
      bio: '请输入个人简介',
      realName: '请输入姓名',
      idCardNo: '请输入身份证号',
      authPhone: '请输入联系电话',
      wechat: '请输入微信',
      alipay: '请输入支付宝账号',
      location: '请输入地址',
      walletBalance: '请输入客户余额',
      companionCommission: '请输入陪玩订单抽成',
      boostCommission: '请输入代练订单抽成',
      giftCommission: '请输入礼物订单抽成'
    },
    gender: {
      female: '女',
      male: '男'
    },
    upload: {
      upload: '上传'
    },
    switch: {
      disable: '禁用',
      enable: '启用'
    }
  },
  client: {
    title: '客户管理',
    columns: {
      customerId: '客户号',
      name: '客户名称',
      gender: '性别',
      vipLevel: '会员等级',
      balance: '客户余额',
      totalSpent: '累计消费',
      wechat: '微信号',
      phone: '电话',
      operation: '操作'
    },
    search: {
      customerId: '客户号',
      name: '客户名称',
      gender: '性别',
      vipLevel: '客户等级',
      phone: '手机号',
      wechat: '微信号',
      status: '使用状态',
      balanceLte: '余额≤',
      balanceGte: '余额≥',
      totalSpentLte: '累计消费≤',
      totalSpentGte: '累计消费≥'
    },
    placeholder: {
      customerId: '请输入客户号',
      name: '请输入客户名称',
      gender: '请选择性别',
      vipLevel: '请选择客户等级',
      phone: '请输入手机号',
      wechat: '请输入微信号'
    },
    buttons: {
      add: '新增客户',
      charge: '充值',
      export: '导出'
    },
    form: {
      name: '客户名称',
      gender: '客户性别',
      vipLevel: '客户会员等级',
      wechat: '客户微信',
      phone: '客户电话',
      balance: '客户余额',
      totalSpent: '累积消费',
      chargeAmount: '充值金额',
      chargeType: '充值类型'
    },
    formPlaceholder: {
      name: '请输入客户名称',
      gender: '请选择客户性别',
      vipLevel: '请选择会员等级',
      wechat: '请输入客户微信',
      phone: '请输入客户电话',
      balance: '请输入客户余额',
      totalSpent: '请输入累积消费',
      chargeAmount: '请输入充值金额',
      chargeType: '请选择充值类型'
    },
    gender: {
      female: '女',
      male: '男'
    }
  },
  order: {
    title: '订单管理',
    columns: {
      orderId: '订单号',
      customerId: '客户号',
      customerName: '客户名称',
      bossName: '老板名称',
      companionType: '陪玩类型',
      companionServer: '陪玩区服',
      duration: '陪玩时长/局数',
      startTime: '开始时间',
      endTime: '结束时间',
      unitPrice: '单价(元)',
      totalPrice: '总价(元)',
      department: '部属',
      dispatcher: '派单人',
      status: '订单状态',
      wins: '胜场',
      losses: '败场',
      battleScreenshot: '战绩截图',
      remark: '备注',
      orderTime: '报单时间',
      reviewTime: '审核时间',
      withdrawApplyTime: '提现申请时间',
      withdrawPassTime: '提现通过时间',
      operation: '操作'
    },
    search: {
      orderId: '订单编号',
      customerId: '客户号',
      dispatcher: '派单人',
      status: '订单状态',
      orderDate: '订单日期'
    },
    placeholder: {
      orderId: '请输入订单号',
      customerId: '请输入客户号',
      dispatcher: '请选择派单人',
      status: '请选择订单状态',
      orderDate: '请选择订单日期'
    },
    buttons: {
      add: '新增',
      viewDetail: '查看详情',
      withdraw: '提现',
      cancel: '撤回'
    },
    messages: {
      withdrawSuccess: '提现请求发起成功！',
      confirmCancel: '确认撤回？'
    },
    expand: '展开',
    collapse: '收起',
    noData: '无',
    form: {
      companionType: '陪玩内容',
      startTime: '服务开始时间',
      endTime: '服务结束时间',
      duration: '陪玩时长/局数',
      gameServer: '游戏区服',
      bossName: '老板名称',
      customer: '客户',
      dispatcher: '派单人',
      department: '部属',
      discount: '折扣',
      hourlyRate: '小时单价',
      totalPrice: '总价',
      wins: '胜场',
      losses: '败场',
      battleScreenshot: '战绩截图',
      remark: '备注',
      isFailed: '是否炸单',
      reviewResult: '审核结果',
      reviewRemark: '审核备注'
    },
    formPlaceholder: {
      companionType: '请选择陪玩内容',
      startTime: '请选择开始时间',
      endTime: '请选择结束时间',
      duration: '请输入陪玩时长',
      gameServer: '请选择游戏区服',
      bossName: '请输入老板名称',
      customer: '请选择客户名',
      dispatcher: '请选择派单人',
      department: '请选择部属',
      discount: '请选择折扣',
      hourlyRate: '请输入小时单价',
      totalPrice: '请输入总价',
      wins: '请输入胜场',
      losses: '请输入败场',
      reviewResult: '请选择审核结果'
    },
    review: {
      pass: '通过',
      reject: '不通过'
    },
    upload: {
      clickToUpload: '点击上传',
      preview: '预览'
    },
    player: {
      username: '陪玩用户名',
      nickname: '陪玩昵称'
    },
    durationUnit: 'h/局',
    yes: '是',
    no: '否'
  },
  role: {
    title: '角色管理',
    roleName: '角色名称',
    roleDesc: '角色描述',
    enabled: '是否启用',
    columns: {
      id: '编号',
      name: '角色名称',
      description: '角色描述',
      userCount: '用户数量',
      createTime: '创建时间',
      status: '是否启用',
      operation: '操作'
    },
    formPlaceholder: {
      name: '请输入角色名称',
      description: '请输入角色描述'
    }
  },
  billing: {
    title: '账单管理'
  },
  dailian: {
    title: '代练管理',
    columns: {
      orderId: '订单号',
      customerId: '客户号',
      customerName: '客户名称',
      bossName: '老板名称',
      gameServer: '代练区服',
      startLevel: '开始段位',
      endLevel: '结束段位',
      finishScreenshot: '完单截图',
      totalPrice: '总价(元)',
      department: '部属',
      dispatcher: '派单人',
      status: '订单状态',
      wins: '胜场',
      losses: '败场',
      battleScreenshot: '战绩截图',
      remark: '备注',
      orderTime: '报单时间',
      reviewTime: '审核时间',
      withdrawApplyTime: '提现申请时间',
      withdrawPassTime: '提现通过时间',
      operation: '操作'
    },
    search: {
      orderId: '订单编号',
      customerId: '客户号',
      dispatcher: '派单人',
      status: '订单状态',
      orderDate: '订单日期'
    },
    placeholder: {
      orderId: '请输入订单号',
      customerId: '请输入客户号',
      dispatcher: '请选择派单人',
      status: '请选择订单状态',
      orderDate: '请选择订单日期'
    },
    buttons: {
      add: '新增',
      viewDetail: '查看详情',
      withdraw: '提现',
      cancel: '撤销'
    },
    messages: {
      withdrawSuccess: '提现请求发起成功！',
      confirmCancel: '确认撤销？'
    },
    expand: '展开',
    collapse: '收起',
    form: {
      gameServer: '游戏区服',
      bossName: '老板名称',
      customer: '客户',
      department: '部属',
      dispatcher: '派单人',
      startLevel: '开始段位',
      endLevel: '结束段位',
      finishScreenshot: '完单截图',
      totalPrice: '总价',
      wins: '胜场',
      losses: '败场',
      battleScreenshot: '战绩截图',
      remark: '备注',
      isFailed: '是否炸单',
      reviewResult: '审核结果',
      reviewRemark: '审核备注'
    },
    formPlaceholder: {
      gameServer: '请选择游戏区服',
      bossName: '请输入老板名称',
      customer: '请选择客户名',
      department: '请选择部属',
      dispatcher: '请选择派单人',
      startLevel: '请输入开始段位',
      endLevel: '请输入结束段位',
      totalPrice: '请输入总价',
      wins: '请输入胜场',
      losses: '请输入败场',
      reviewResult: '请选择审核结果'
    },
    player: {
      username: '代练用户名',
      nickname: '代练昵称'
    },
    upload: {
      clickToUpload: '点击上传',
      preview: '预览'
    },
    review: {
      pass: '通过',
      reject: '不通过'
    },
    yes: '是',
    no: '否'
  },
  gift: {
    title: '礼物管理',
    columns: {
      orderId: '订单号',
      customerId: '客户号',
      customerName: '客户名称',
      bossName: '老板名称',
      giftAmount: '礼物金额(元)',
      dispatcher: '派单人',
      department: '部属',
      status: '订单状态',
      screenshot: '截图凭证',
      remark: '备注',
      orderTime: '报单时间',
      reviewTime: '审核时间',
      withdrawApplyTime: '提现申请时间',
      withdrawPassTime: '提现通过时间',
      operation: '操作'
    },
    search: {
      orderId: '订单编号',
      customerId: '客户号',
      dispatcher: '派单人',
      status: '订单状态',
      orderDate: '订单日期'
    },
    placeholder: {
      orderId: '请输入订单号',
      customerId: '请输入客户号',
      dispatcher: '请选择派单人',
      status: '请选择订单状态',
      orderDate: '请选择订单日期'
    },
    buttons: {
      add: '新增',
      viewDetail: '查看详情',
      withdraw: '提现',
      cancel: '撤回'
    },
    messages: {
      withdrawSuccess: '提现请求发起成功！',
      confirmCancel: '确认撤回？'
    },
    expand: '展开',
    collapse: '收起',
    form: {
      bossName: '老板名称',
      customer: '客户',
      department: '部属',
      dispatcher: '派单人',
      totalPrice: '总价',
      screenshot: '截图凭证',
      remark: '备注',
      reviewResult: '审核结果',
      reviewRemark: '审核备注'
    },
    formPlaceholder: {
      bossName: '请输入老板名称',
      customer: '请选择客户名',
      department: '请选择部属',
      dispatcher: '请选择派单人',
      totalPrice: '请输入总价',
      reviewResult: '请选择审核结果'
    },
    player: {
      username: '陪玩/代练用户名',
      nickname: '陪玩/代练昵称'
    },
    upload: {
      clickToUpload: '点击上传',
      preview: '预览'
    },
    review: {
      pass: '通过',
      reject: '不通过'
    }
  },
  rankList: {
    title: '排行榜',
    date: '日期',
    datePlaceholder: '请选择日期',
    export: '导出',
    participants: '{count}人参与',
    myRank: '您目前排行',
    rankPosition: '第{rank}名',
    myValue: '，您的{label}为',
    noRank: '暂无排名',
    male: '男',
    female: '女',
    overall: '综合',
    exportSuccess: '导出任务已提交，请在下载中心查看进度',
    rankSuffix: '榜',
    rank: '排名',
    nickname: '昵称',
    winRate: '胜率',
    wins: '胜{count}',
    losses: '负{count}',
    reset: '复位'
  },
  download: {
    title: '下载中心',
    refresh: '刷新',
    createTime: '创建时间：',
    search: '查询',
    reset: '重置',
    autoRefreshHint: '有任务正在处理中，页面将自动刷新进度...',
    columns: {
      taskName: '任务名称',
      type: '类型',
      status: '状态',
      dataCount: '数据量',
      creator: '创建人',
      createTime: '创建时间',
      finishTime: '完成时间',
      operation: '操作'
    },
    status: {
      pending: '待处理',
      processing: '处理中',
      success: '成功',
      failed: '失败'
    },
    messages: {
      downloadUrlFailed: '下载链接获取失败',
      downloadFailed: '下载失败'
    },
    buttons: {
      download: '下载'
    },
    noData: '无数据',
    processing: '处理中...',
    exportFailed: '导出失败',
    ranges: {
      today: '今天',
      thisWeek: '本周',
      lastWeek: '上周',
      thisMonth: '本月',
      lastMonth: '上月',
      last3Months: '近三月',
      last6Months: '近半年'
    }
  },
  personal: {
    title: '个人中心',
    overview: '概览',
    changeAvatar: '修改头像',
    resetPassword: '重置密码',
    form: {
      oldPassword: '原密码',
      newPassword: '新密码',
      confirmPassword: '确认新密码'
    },
    placeholder: {
      oldPassword: '请输入原密码',
      newPassword: '请输入新密码',
      confirmPassword: '请再次输入新密码'
    },
    messages: {
      uploadImageOnly: '请上传图片文件！请手动删除当前文件。',
      uploadJpgPng: '请上传jpg/jpeg或png图片文件！请手动删除当前文件。',
      uploadSizeLimit: '上传文件大小不能超过10Mb！请手动删除当前文件。',
      uploadSuccess: '上传成功！',
      passwordMismatch: '两次新密码输入不一样！请重新输入！',
      resetSuccess: '重置密码成功！'
    }
  },
  dataScreen: {
    title: '数据大屏',
    noPermission: '您没有权限访问数据大屏',
    sections: {
      companionOrderRank: '陪玩接单排行',
      companionAmountRank: '陪玩金额排行',
      giftPopularityRank: '礼物人气排行',
      todayRevenue: '今日营业额',
      realTimeOrderAmount: '实时订单金额',
      realTimeComplaints: '实时客诉',
      customerConsumeRank: '客户消费排行',
      companionTypeDistribution: '陪玩类型分布',
      giftIncomeRank: '礼物收入排行'
    }
  },
  dict: {
    title: '字典管理'
  },
  system: {
    title: '系统管理'
  },
  log: {
    title: '日志管理'
  },
  registerReview: {
    title: '注册审核',
    columns: {
      username: '用户名',
      nickname: '用户昵称',
      phone: '手机号',
      wechat: '微信',
      alipay: '支付宝账户',
      realName: '真实姓名',
      idCard: '身份证号',
      location: '地区',
      requestTime: '请求时间',
      requestStatus: '请求状态',
      operation: '操作'
    },
    search: {
      status: '请求状态'
    },
    modal: {
      title: '审核注册请求',
      basicInfo: '基本信息',
      identityInfo: '实名信息',
      role: '申请角色',
      reviewResult: '审核结果',
      reviewPlaceholder: '请选择审核结果'
    },
    buttons: {
      review: '审核',
      submit: '提交',
      cancel: '取消'
    }
  },
  afterSale: {
    title: '售后管理'
  },
  formRules: {
    required: '请{action}{label}',
    input: '输入',
    select: '选择',
    phone: '请输入正确的手机号',
    idCard: '请输入正确的身份证号',
    positiveNumber: '{label}不能为负数',
    rangeNumber: '{label}必须在 {min}-{max} 之间'
  },
  errors: {
    updatePermission: '更新权限'
  }
}
